import desktopIcons from '../data/desktop-icons.json';
import type { DesktopIcon } from '../types/content';
import { openApp } from '../os/WindowManager';

export function initSkipNav(host: HTMLElement): void {
  const skip = document.createElement('a');
  skip.className = 'skip-link';
  skip.href = '#a11y-list';
  skip.textContent = 'Skip to desktop icons';
  host.append(skip);

  const nav = document.createElement('nav');
  nav.id = 'a11y-list';
  nav.hidden = true;
  nav.setAttribute('aria-label', 'Desktop icons');
  const heading = document.createElement('strong');
  heading.textContent = 'Ben95';
  nav.append(heading);

  for (const icon of desktopIcons as DesktopIcon[]) {
    const a = document.createElement('a');
    a.href = `#/${icon.appId}`;
    a.textContent = icon.label;
    a.addEventListener('click', (e) => {
      e.preventDefault();
      openApp(icon.appId, icon.payload);
      nav.hidden = true;
    });
    nav.append(a);
  }

  skip.addEventListener('click', (e) => {
    e.preventDefault();
    nav.hidden = false;
    nav.querySelector('a')?.focus();
  });

  host.append(nav);
}
